<template>
  <div>
    <bread-crumb />
    <div class="contentRepeatDetail">
      <div class="card-content">
        <div class="flex title">
          <div class="label">标题</div>
          <div class="articleContent">{{title}}</div>          
        </div>
        <div class="flex content">
          <div class="label">正文</div>
          <div class="articleContent">{{content}}</div>
        </div>
      </div>
      <c-title title="查重结果"/>
      <div class="original-styles" v-if="tableData.length > 0">
        <p class="content-item-label"><span /></p>
        <span class="black" v-if="articleOriginality">本文共{{words}}字，原创度<span class="red">{{
            this.articleOriginality
          }}%</span></span>
        <span class="black" v-if="originalityCheckTime">历史查重时间：{{ this.originalityCheckTime }}</span>
        {{ this.articleOriginalityText || '' }}
      </div>
      <div class="original-styles" v-if="articleOriginality == 100">原创度100%，其他平台无重复内容</div>
      <div class="item-table" v-if="tableData.length > 0">
        <el-table
          :data="tableData"
          border
          size="mini"
          style="width: 100%">
          <el-table-column
            label="序号"
            type="index"
            align="center"
            width="60">
          </el-table-column>
          <el-table-column
            prop="vioTitle"
            label="侵权文章"
            align="center"
            show-overflow-tooltip="true"
            >
          </el-table-column>
          <el-table-column
            prop="similarity"
            align="center"
            label="相似度"
            width="100">
            <template slot-scope="scope">
              {{ `${(scope.row['similarity'] * 100).toFixed(0)}%` }}
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="侵权作者"
            align="center"
            width="100"
            show-overflow-tooltip="true"
            >
          </el-table-column>
          <el-table-column
            prop="platform"
            label="侵权平台"
            align="center"
            show-overflow-tooltip="true"
            >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <el-button @click="redirectTo(scope.$index)" type="text" size="small">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @sizePageChange="paginationChangeProduct"
          :paginationDatas="paginationDataProduct"
        ></pagination>
      </div>
    </div>
  </div>
</template>

<script>
import breadCrumb from "@/components/breadCrumb";
import CTitle from '@/components/customize/CTitle';
import pagination from '@/components/pagination'
import {
  healthCmpBizPageDuplicateRecord,
  healthCmpBizQueryByContentSnippetId,
  querySnippetRiskControl
} from "@/api/man";
export default {
  name: "medicalCenter",
  data() {
    return {
      articleId: '',
      title: '',
      content: '',
      tableData: [],
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [5, 10, 20, 30, 50]
      },
    }
  },
  components: {
    breadCrumb,
    CTitle,
    pagination,
  },
  created() {
    this.articleId = this.$route.query.id;
    this.tenantId = this.$commonJs.getTenantId();
    this.healthCmpBizPageDuplicateRecord(this.articleId, this.tenantId, 1, 1, 10);
    this.healthCmpBizQueryByContentSnippetId(this.tenantId, this.articleId)
    this.querySnippetRiskControl(this.articleId, this.tenantId);
  },
  methods: {
    healthCmpBizPageDuplicateRecord(contentId, tenantId, sourceType, pageNo, pageSize) {
      healthCmpBizPageDuplicateRecord({tenantId, contentId, sourceType, pageNo, pageSize}).then((res) => {
        const {data , ...pageConfig} = res;
        this.tableData = data;
        this.paginationDataProduct = {
          ...this.paginationDataProduct,
          total: pageConfig.totalCount,
          currentPage: pageConfig.pageNo,
          pageSize: pageConfig.pageSize,
        }
      })
    },
    healthCmpBizQueryByContentSnippetId(tenantId, contentSnippetId){
      healthCmpBizQueryByContentSnippetId({tenantId, contentSnippetId}).then((res) => {
        this.title = res.title;
        this.content = res.content;
        this.words = res.words;
        this.originality = res.originality;
      })
    },
    querySnippetRiskControl(contentSnippetId, tenantId) {
      querySnippetRiskControl({contentSnippetId, tenantId}).then((res) => {
        if (res.code) { // code 不为 0000 时
          this.isArticleOriginaly = false
          this.articleOriginalityText = res.msg;
          this.articleOriginalityCode = res.code;
          if (res.data) {
            this.articleOriginality = res.originality + '';
            this.originalityCheckTime = res.originalityCheckTime;
          }
        } else { // code 为 0000 时
          this.articleOriginality = res.originality + '';
        }
      })
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct=val
      this.healthCmpBizPageDuplicateRecord(this.articleId, this.tenantId, 1, val.currentPage, val.pageSize);
    },
    redirectTo(id) {
      let routeUrl = this.$router.resolve({
        path: `/contentTool/contentRecord`,
        query: {
          id: this.articleId,
          tenantid: this.tenantId,
          paragraphId: id,
          pageSizes: this.paginationDataProduct.pageSize,
          type: 2,
        }
      })
      window.open(routeUrl.href, '_blank');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../styles/element.scss';
@import "@/styles/article_common.scss";
.contentRepeatDetail {
  padding: 24px 20px 30px 20px;
  background: #ffffff;
  position: relative;
  font-size: 14px;
  line-height: 1.5;
  .label {
    min-width: 50px;
    min-height: 40px;
    text-align: center;
    margin-right: 10px;
  }
  .title {
    overflow-x: hidden;
    word-break: break-all;
    line-height: 20px;
    overflow-x: hidden;
    word-break: break-all;    
  }
  .content {
    margin-top: 10px;
  }
  .card-content {
    margin-bottom: 15px;
  }
  .original-styles {
    line-height: 40px;
    .red {
      color: red;
    }
  }
}
</style>
